export interface Bonus {
  number: string
  title: string
  tagline: string
  value: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Pronto Classe™',
    tagline:
      "Prepara una lezione completa in 10 minuti. Metodo rapido, checklist e template pronto all'uso. Perfetto per i momenti di fretta.",
    value: '€29',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f9912846-4252-4596-b2d3-d94b4bf6fab2.jpg',
    alt: 'Copertina del Bonus 1: Pronto Classe, con una donna in meditazione.',
  },
  {
    number: '2',
    title: 'Varianti Intelligenti™',
    tagline:
      'Adatta ogni classe a 3 livelli (base, standard, avanzato). Frasi pronte, tabelle pratiche: nessun gruppo è impossibile.',
    value: '€27',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/26364c74-7034-4dfb-a287-6dc571b0903a.jpg',
    alt: "Copertina del Bonus 2: Varianti Intelligenti, con una donna nella posizione dell'angolo laterale.",
  },
  {
    number: '3',
    title: 'Cueing Essenziale™',
    tagline:
      'Frasi pronte per guidare con sicurezza. Script per apertura, transizioni, allineamento, profondità e integrazione.',
    value: '€24',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c353a1e2-ad43-4d8f-861c-8f55b0e993f5.jpg',
    alt: 'Copertina del Bonus 3: Cueing Essenziale, con una donna in torsione seduta.',
  },
  {
    number: '4',
    title: 'Chiusure Profonde™',
    tagline:
      '21 script per Savasana e chiusure di classe. Rendono il finale della tua pratica memorabile e profondo.',
    value: '€21',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4fa30dbd-0faa-4507-b6af-190e4aeb6266.jpg',
    alt: 'Copertina del Bonus 4: Chiusure Profonde, con una donna nella posizione del bambino.',
  },
  {
    number: '5',
    title: 'Calendario Lezioni Pro™',
    tagline:
      '4 settimane di programmazione già pianificata. Alterna energia, forza, respiro e rilascio in modo intelligente.',
    value: '€17',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e4952f1b-f221-4dd6-b054-be4f30255031.jpg',
    alt: 'Copertina del Bonus 5: Calendario Lezioni Pro, con una donna in meditazione al tramonto.',
  },
]
